import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PageWrapper } from '@/components/PageWrapper';

/** PayPal `cancel_url` lands here. */
export function PaypalCancel() {
  const navigate = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => navigate('/settings', { replace: true }), 800);
    return () => clearTimeout(t);
  }, [navigate]);

  return (
    <PageWrapper className="bg-app">
      <div className="max-w-md mx-auto w-full min-w-0 px-6 py-16 text-center">
        <p className="font-body text-primary">Checkout cancelled.</p>
        <p className="font-body text-sm text-secondary mt-2">Returning to Settings…</p>
      </div>
    </PageWrapper>
  );
}
